import { generatePath, RouteObject } from 'react-router-dom';
import { ProfilePage } from './pages/profile/profile.page';
import { ProfileSecurityPage } from './pages/security/security.page';

import { ProfileRoutes } from './constants';
import { DistrictListPage } from '../district/pages/district-list/district-list.page';
import { FamiliesListAdminLevelPage } from '../family/pages/family-list/family-list-admin-level.page';
import { DistributionPage } from '../_core/pages/distribution/distribution.page';
import { EngagementsListAdminLevelPage } from '../engagement/pages/engagements-list/engagement-list-admin-level.page';
import { FamilyDetailsPage } from '../family/pages/family-details/family-details.page';
import { ProvidersDetailsPage } from '../providers/pages/providers-details/providers-details.page';
import { EngagementDetailsPage } from '../engagement/pages/engagements-details/engagements-details.page';
import { SurveyTemplateListAdminLevelPage } from '../survey/pages/survey-template-list/survey-list-admin-level.page';
import { SurveyTemplateActionPage } from '../survey/pages/survey-template-actions/survey-template-action.page';
import { DashboardAdminLevelPage } from '../dashboard/pages/dashboard-admin-level.page';
import { ProvidersListAdminLevelPage } from '../providers/pages/providers-list/provider-list-admin-level.page';
import { SurveyStatisticsAdminLevelPage } from '../survey/pages/survey-statistic/survey-statistics/survey-statistic-admin.page';
import { QuestionAnswersAdminLevelPage } from '../survey/pages/survey-statistic/question-answers/question-answers-admin.page';
import { FamilyAnswersAdminLevelPage } from '../survey/pages/survey-statistic/family-answers/family-answers-admin.page';
import { AnalyticsAdminLevelPage } from '../analytics/pages/analytics-admin-level.page';

export const ProfileSuperAdminModuleRouter: RouteObject[] = [
	{
		path: ProfileRoutes.Root,
		element: <DashboardAdminLevelPage />,
		handle: { title: 'nav.dashboard', needsPaper: false },
	},
	{
		path: ProfileRoutes.Analytics,
		element: <AnalyticsAdminLevelPage />,
		handle: { title: 'nav.analytics', needsPaper: false },
	},
	{ path: ProfileRoutes.Districts, element: <DistrictListPage />, handle: { title: 'nav.districts' } },
	{
		path: ProfileRoutes.Engagements,
		element: <EngagementsListAdminLevelPage />,
		handle: { title: 'nav.engagements', needsPaper: false },
	},
	{
		path: ProfileRoutes.EngagementDetails,
		element: <EngagementDetailsPage />,
		handle: {
			title: 'headers.engagement-details',
			needsPaper: false,
			to: { path: ProfileRoutes.Engagements },
		},
	},

	{
		path: ProfileRoutes.EngagementDetailsLL,
		element: <EngagementDetailsPage />,
		handle: {
			title: 'headers.engagement-details-ll',
			needsPaper: false,
			to: { path: ProfileRoutes.Engagements },
		},
	},

	{ path: ProfileRoutes.Providers, element: <ProvidersListAdminLevelPage />, handle: { title: 'nav.providers' } },
	{
		path: ProfileRoutes.ProviderDetails,
		element: <ProvidersDetailsPage />,
		handle: {
			title: 'headers.providers-details',
			needsPaper: false,
			to: { path: ProfileRoutes.Providers },
		},
	},

	{ path: ProfileRoutes.Families, element: <FamiliesListAdminLevelPage />, handle: { title: 'nav.families' } },
	{
		path: ProfileRoutes.FamilyDetails,
		element: <FamilyDetailsPage />,
		handle: { title: 'headers.family-details', needsPaper: false, to: { path: ProfileRoutes.Families } },
	},
	{
		path: ProfileRoutes.SurveyTemplates.Root,
		element: <SurveyTemplateListAdminLevelPage />,
		handle: { title: 'nav.survey' },
	},
	{
		path: ProfileRoutes.SurveyTemplates.Creating,
		element: <SurveyTemplateActionPage />,
		handle: { title: 'headers.survey-creating', to: { path: ProfileRoutes.SurveyTemplates.Root }, needsPaper: false },
	},
	{
		path: ProfileRoutes.SurveyTemplates.Editing,
		element: <SurveyTemplateActionPage />,
		handle: { title: 'headers.survey-editing', to: { path: ProfileRoutes.SurveyTemplates.Root }, needsPaper: false },
	},
	{
		path: ProfileRoutes.SurveyTemplates.Overview,
		element: <SurveyStatisticsAdminLevelPage />,
		handle: {
			title: 'headers.survey-template-name',
			to: { path: ProfileRoutes.SurveyTemplates.Root },
		},
	},
	{
		path: ProfileRoutes.SurveyTemplates.QuestionStats,
		element: <QuestionAnswersAdminLevelPage />,
		handle: {
			title: 'headers.survey-template-name',
			to: (params: { surveyTemplateId: any }) => ({
				path: generatePath(ProfileRoutes.SurveyTemplates.Overview, {
					surveyTemplateId: params.surveyTemplateId,
				}),
			}),
		},
	},
	{
		path: ProfileRoutes.SurveyTemplates.FamilyStats,
		element: <FamilyAnswersAdminLevelPage />,
		handle: {
			title: 'headers.survey-template-name',
			to: (params: { surveyTemplateId: any }) => ({
				path: generatePath(ProfileRoutes.SurveyTemplates.Overview, {
					surveyTemplateId: params.surveyTemplateId,
				}),
			}),
		},
	},
];

export const ProfileModuleRouter: RouteObject[] = [
	{ path: ProfileRoutes.Distribute, element: <DistributionPage /> },
	{
		path: ProfileRoutes.Profile,
		element: <ProfilePage />,
		handle: { title: 'nav.profile', to: -1 },
	},
	{
		path: ProfileRoutes.SecuritySettings,
		element: <ProfileSecurityPage />,
		handle: { title: 'nav.profile', to: -1 },
	},
];
